import { render, staticRenderFns } from "./IconSteeringWheel.vue?vue&type=template&id=2c615fd8"
import script from "./IconSteeringWheel.vue?vue&type=script&lang=js"
export * from "./IconSteeringWheel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports